import {
    Component,
    EventEmitter,
    Input,
    Output,
    TemplateRef,
} from '@angular/core';

import {
    CmpsScoreSectionData,
    CmpsScoreSectionMenuData,
    CmpsScoreSectionTrendData,
    CmpsScoreSectionTrendType,
} from './scorecard-score-section.model';

@Component({
    selector: 'cmps-scorecard-score-section',
    template: `
        <div class="cmps-scorecard-score-section-container">
            <div class="cmps-scorecard-score-section-labels">
                <div class="cmps-scorecard-score-section--item">
                    <h4>{{ adjustScoreData.scoreLabel }}</h4>
                </div>
                <div
                    class="cmps-scorecard-score-section--item"
                    *ngIf="originalScoreData"
                >
                    <h5>{{ originalScoreData.scoreLabel }}</h5>
                </div>
            </div>
            <div class="cmps-scorecard-score-section--content">
                <div class="cmps-scorecard-score-section--item">
                    <div class="cmps-scorecard-score-section--item-content">
                        <h4>{{ adjustScoreData.scoreValue }}</h4>
                    </div>
                </div>
                <div
                    class="cmps-scorecard-score-section--item"
                    *ngIf="originalScoreData"
                >
                    <div
                        class="cmps-scorecard-score-section--item-content-original-score"
                    >
                        <h4>{{ originalScoreData.scoreValue }}</h4>
                    </div>
                </div>
                <div class="cmps-scorecard-score-section--item">
                    <div class="cmps-scorecard-score-section--item-content">
                        <ng-container
                            *ngIf="
                                trendData &&
                                    trendData.trend !==
                                        _CmpsScoreSectionTrendType.UNKNOWN;
                                else trendWithoutData
                            "
                        >
                            <button
                                cmpsIconButton
                                (click)="trendAction.emit($event)"
                                [cmpsTooltipTrigger]="trendTooltip"
                                placement="top-center"
                                [disabled]="trendData.trendButtonState"
                            >
                                <ng-container
                                    *ngIf="
                                        trendData &&
                                            trendData.trend ===
                                                _CmpsScoreSectionTrendType.NO_CHANGE;
                                        else trendTemplate
                                    "
                                >
                                    <cmps-icon
                                        class="cmps-scorecard-score-section--item-no-trend"
                                        svgIcon="__internal:trending-neutral"
                                        [style.fill]="trendData.trendColor"
                                    ></cmps-icon>
                                </ng-container>
                                <ng-template #trendTemplate>
                                    <cmps-icon
                                        [svgIcon]="
                                            trendData &&
                                            trendData.trend ===
                                                _CmpsScoreSectionTrendType.UP
                                                ? '__internal:trending-up'
                                                : '__internal:trending-down'
                                        "
                                        [style.fill]="trendData.trendColor"
                                    ></cmps-icon>
                                </ng-template>
                                <span
                                    cmpsIconButtonLabel
                                    [style.color]="trendData.trendColor"
                                    >{{ trendData.trendValue }}</span
                                >
                            </button>
                        </ng-container>
                        <ng-template #trendWithoutData>
                            <span
                                class="cmps-scorecard-score-section--item-unknown-trend"
                                [cmpsTooltipTrigger]="trendTooltip"
                                placement="top-center"
                                [style.color]="trendData.trendColor"
                                >{{ trendData.trendValue }}</span
                            >
                        </ng-template>
                    </div>
                    <ng-template #trendTooltip>
                        <div
                            class="cmps-scorecard-score-section-tooltip-content"
                            *ngFor="let i of trendData.trendTooltip"
                        >
                            <div
                                class="cmps-scorecard-score-section-tooltip-content-child"
                            >
                                <strong>{{ i.label }}: </strong>{{ i.value }}
                            </div>
                        </div>
                    </ng-template>
                </div>

                <div
                    class="cmps-scorecard-score-section--item cmps-scorecard-score-section-menu-trigger"
                >
                    <div class="cmps-scorecard-score-section--item-content">
                        <cmps-icon svgIcon="__internal:dots"></cmps-icon>
                    </div>

                    <div
                        class="cmps-scorecard-score-section-menu"
                        *ngIf="dropdownMenuData.dropdownMenuValues"
                    >
                        <ng-container
                            *ngFor="
                                let i of dropdownMenuData.dropdownMenuValues
                            "
                        >
                            <div
                                class="cmps-scorecard-score-section-menu-item"
                                [ngClass]="{
                                    'cmps-scorecard-score-section-menu-item--selected':
                                        i.selected
                                }"
                                (click)="selectedAction.emit(i.id)"
                            >
                                <div *ngIf="i.selected">
                                    <cmps-icon
                                        svgIcon="__internal:check"
                                    ></cmps-icon>
                                </div>
                                <span>{{ i.value }}</span>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>
            <div class="cmps-scorecard-component--optional-content">
                <ng-container *ngTemplateOutlet="templateData"></ng-container>
            </div>
        </div>
    `,
    host: {
        class: 'cmps-scorecard-score-section',
        '[class.cmps-scorecard-score-section-container-with-score-only]':
            '!originalScoreData',
    },
})
export class CmpsScoreCardScoreSectionComponent {
    @Input() adjustScoreData: CmpsScoreSectionData;
    @Input() originalScoreData: CmpsScoreSectionData;
    @Input() trendData: CmpsScoreSectionTrendData;
    @Input() dropdownMenuData: CmpsScoreSectionMenuData;
    @Input() templateData: TemplateRef<any> | null;

    @Output() selectedAction: EventEmitter<MouseEvent | KeyboardEvent>;
    @Output() trendAction: EventEmitter<MouseEvent | KeyboardEvent>;

    /** @private */ _CmpsScoreSectionTrendType = CmpsScoreSectionTrendType;
    constructor() {
        this.trendAction = new EventEmitter();
        this.selectedAction = new EventEmitter();
    }

    ngOnDestroy(): void {
        this.trendAction.complete();
        this.selectedAction.complete();
    }
}
